import {CSSObject, Typography, TypographyProps, styled} from "@mui/material"
import merge from "lodash/merge"
import {BannerStyles, ButtonStyles, TextStyles} from "./models"
import {removeUnsetProps} from "../utils"

export const SingleColumnContainer = styled("div", {shouldForwardProp: prop => !String(prop).startsWith("$")})<{
    $bannerStyles: BannerStyles
}>(({theme, $bannerStyles}) => {
    const override = removeUnsetProps({
        backgroundColor: $bannerStyles.backgroundColor,
    })
    return merge(
        {
            padding: "0.75rem 1rem 0.75rem 1rem",
            backgroundColor: theme.colours.plp.searchBanner.default.stripBanner.backgroundColor,
        },
        override,
    )
})

export const ThreeColumnContainer = styled("div", {shouldForwardProp: prop => !String(prop).startsWith("$")})<{
    $bannerStyles: BannerStyles
}>(({theme, $bannerStyles}) => {
    const override = removeUnsetProps({
        backgroundColor: $bannerStyles.backgroundColor,
    })
    return merge(
        {
            padding: "0.5rem 1rem",
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: theme.colours.plp.searchBanner.default.stripBanner.backgroundColor,
        },
        override,
    )
})

export const ComponentContainer = styled("div")({
    display: "flex",
    justifyContent: "center",
    flex: "1 0 0",
})

export const StyledImage = styled("img")({
    maxWidth: "9.375rem",
    maxHeight: "3rem",
})

export const UnstyledLink = styled("a")({
    textDecoration: "none",
})

export const TextContainer = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$singleColumn: boolean}>(({$singleColumn}) => ({
    display: $singleColumn ? "block" : "flex",
    width: $singleColumn ? "100%" : "40%",
}))

export const StyledTypography = styled(Typography, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<TypographyProps & {$textStyles: TextStyles; $singleColumn: boolean}>(({theme, $textStyles, $singleColumn}) => {
    const override = removeUnsetProps({
        color: $textStyles.textColor,
        fontWeight: $textStyles.fontWeight,
        textDecoration: $textStyles.textDecoration,
        fontSize: $textStyles.fontSize,
        textAlign: $textStyles.textAlign,
    } as CSSObject)
    return merge(
        {
            color: theme.colours.plp.searchBanner.default.stripBanner.typography.textColor,
            textDecoration: "none",
            fontSize: "0.875rem",
            textAlign: $singleColumn ? "center" : "left",
            whiteSpace: "pre-line",
        } as CSSObject,
        override,
    )
})

export const StyledButton = styled("button", {shouldForwardProp: prop => !String(prop).startsWith("$")})<{
    $buttonStyles: ButtonStyles
}>(({theme, $buttonStyles}) => {
    const override = removeUnsetProps({
        borderColor: $buttonStyles.borderColor,
        borderRadius: $buttonStyles.borderRadius,
        backgroundColor: $buttonStyles.buttonBackgroundColor,
    } as CSSObject)
    return merge(
        {
            textWrap: "nowrap",
            padding: "0.5rem 1.5rem",
            backgroundColor: theme.colours.plp.searchBanner.default.stripBanner.button.backgroundColor,
            color: theme.colours.plp.searchBanner.default.stripBanner.button.contrastTextColor,
            border: `1px solid ${theme.colours.plp.searchBanner.default.stripBanner.button.borderColor}`,
            borderRadius: "62.438rem",
            cursor: "pointer",
        } as CSSObject,
        override,
    )
})

export const ButtonText = styled(Typography, {shouldForwardProp: prop => !String(prop).startsWith("$")})<
    TypographyProps & {$textStyles: ButtonStyles}
>(({theme, $textStyles}) => {
    const override = removeUnsetProps({
        color: $textStyles.buttonTextColor,
        fontWeight: $textStyles.buttonFontWeight,
    } as CSSObject)
    return merge(
        {
            fontSize: "1rem",
            color: theme.colours.plp.searchBanner.default.stripBanner.button.contrastTextColor,
            fontWeight: 500,
        } as CSSObject,
        override,
    )
})
